import { ApiService } from "../api.service";
import {CommonService} from '../common.service';

export class AbilityConfig {

  apiService: ApiService;
  commonService: CommonService;
  abilityList: any = {
    "辅导": {
      value: 105
    },
    "打造高效团队": {
      value: 115
    },
    "授权": {
      value: 125
    },
    "计划与组织": {
      value: 145
    },
    "协作": {
      value: 155
    },
    "影响力": {
      value: 165
    },
    "影响力专业版": {
      value: 1650
    },
    "决策": {
      value: 175
    },
    "驱动变革":{
      value:185
    },
    "达至最佳绩效":{
      value: 305
    },
    "目标选才":{
      value: 315
    },
    "解决冲突":{
      value: 325
    },
    "领导力精要":{
      value: 335
    }
  };
  practiceMetaIdList: any = {
    "1": {
      value: 105
    },
    "405": {
      value: 105
    },
    "5": {
      value: 115
    },
    "6": {
      value: 125
    },
    "403": {
      value: 125
    },
    "7": {
      value: 145
    },
    "8": {
      value: 155
    },
    "9": {
      value: 165
    },
    "16": {
      value: 1650
    },
    "10": {
      value: 175
    },
    "11":{
      value:185
    },
    "13":{
      value: 305
    },
    "406":{
      value: 305
    },
    "201":{
      value: 315
    },
    "15":{
      value: 325
    },
    "202":{
      value: 335
    },
    "402":{
      value: 335
    },
    "606":{
      value:606
    },
    "607":{
      value:607
    }
  };

  constructor(apiService: ApiService,commonService: CommonService) {
    this.apiService = apiService;
    this.commonService = commonService;
  }

  /* 获取能力完成状态 */
  getOnceino(abilityName) {
    let abilityValue = this.abilityList[abilityName].value;
    return this.apiService.ajax({
      'type': 'get',
      'url': '/sr/onceino/' + abilityValue
    });
  }
  /* 获取能力完成状态 */
  getOnceinoByPracticeMetaId(practiceMetaId) {
    // return this.commonService.getOnceIno(this.commonService.getOnceValue(practiceMetaId,2)).then();
    // let practiceMetaValue = this.practiceMetaIdList[practiceMetaId.toString()].value;
    return this.apiService.ajax({
      'type': 'get',
      'url': '/sr/onceino/' + this.commonService.getOnceValue(practiceMetaId,2)
    });
  }
  /* 设置能力完成状态 */
  setOnceinoByPracticeMetaId(practiceMetaId) {
    // return this.commonService.getOnceIno(this.commonService.getOnceValue(practiceMetaId,2)).then();
    // let practiceMetaValue = this.practiceMetaIdList[practiceMetaId.toString()].value;
    return this.apiService.ajax({
      'type': 'post',
      'url': '/sr/onceino/' + this.commonService.getOnceValue(practiceMetaId,2)
    });
  }
  /* 获取情景模拟列表地址（由于样式及布局不同，不能使用同一页面） */
  getPracticeLinkList(name,learningPathId,practiceMetaId) {
    let link = [];
    if(name == '辅导') {
      link = [learningPathId, practiceMetaId, 'case-practice'];
    } else if(name == '打造高效团队') {
      if(practiceMetaId == 204){
        link = ['case-practice-executive',20401];
      }else{
        link = ['case-practice-team', learningPathId, practiceMetaId, 1, 0];
      }
    } else if(name == '授权') {
      if(practiceMetaId == 303){
        link = ['case-practice-executive',30301];
      }else{
        link = [learningPathId, practiceMetaId, 'case-practice-authorization'];
      }
    } else if(name == '计划与组织') {
      link = [learningPathId, practiceMetaId, 'case-practice-p-and-o'];
    } else if(name == '协作') {
      if(practiceMetaId == 304){
        link = ['case-practice-executive',30401];
      }else{
        link = [learningPathId, practiceMetaId, 'case-practice-cooperation'];
      }
    } else if(name == '影响力') {
      if(practiceMetaId == 607 || practiceMetaId == 16){
        //影响力专业版
        link = [learningPathId, practiceMetaId, 'case-practice-influence-pro'];
      }else if(practiceMetaId == 307){
        link = ['case-practice-executive',30701];
      }else if(practiceMetaId == 317){
        link = ['case-practice-executive',31701];
      }else if(practiceMetaId == 327){
        link = ['case-practice-executive',32701];
      }else{
        //普通版
        link = [learningPathId, practiceMetaId, 'case-practice-influence'];
      }
    }
    // else if(name == '影响力专业版') {
    //   link = [learningPathId, practiceMetaId, 'case-practice-influence-pro'];
    // }
    else if(name == '决策') {
      if(practiceMetaId == 308){
        link = ['case-practice-executive',30801];
      } else if(practiceMetaId == 318) {
        link = ['case-practice-executive',31801];
      }else{
        link = [learningPathId, practiceMetaId, 'case-practice-influence'];
      }
    } else if(name == '驱动变革') {
      if(practiceMetaId == 309) {
        link = ['case-practice-executive',30901];
      }else{
        link = ['case-practice-revolution',learningPathId, practiceMetaId];
      }
    }else if(name == '达至最佳绩效') {
      link = ['case-practice-performance',learningPathId, practiceMetaId];
    }else if(name == '解决冲突') {
      link = ['case-practice-clash',learningPathId, practiceMetaId];
    }else if(name == '目标选才' && practiceMetaId == 201) {
      link = ['case-practice-executive',20101];
    }else if(name == '目标选才' && practiceMetaId == 301){//大健康目标选才
      link = ['egret-practice-ts',30101];
    }else if(name == '领导力精要' && practiceMetaId == 202) {
      link = ['egret-practice-communicate',20201];
    }else if(name == '领导力精要' && practiceMetaId == 312) {
      link = ['case-practice-executive',31201];
    }else if(practiceMetaId == 302){
      link = ['egret-practice-communicate',30201];//行业化领导力精要
    }else if(practiceMetaId == 402) {
      link = ['egret-practice-communicate',40201];
    }else if(practiceMetaId == 208) {
      link = ['case-practice-executive',20801];
    }else if(practiceMetaId == 209) {
      link = ['case-practice-executive',20901];
    }else if(practiceMetaId == 210) {
      link = ['case-practice-executive',21001];
    }else if(practiceMetaId == 211) {
      link = ['case-practice-executive',21101];
    }else if(practiceMetaId == 212) {
      link = ['case-practice-executive',21201];
    }else if(practiceMetaId == 311) {
      link = ['case-practice-executive',31101];
    }
    console.log(link);
    return link;
  }

}



// WEBPACK FOOTER //
// ./src/app/ability-config/ability-config.ts